import { VirtualRoomRouterStoreSelectors } from '@era/stores';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromMediaState from './media.reducer';

export const selectMediaState = createFeatureSelector<fromMediaState.MediaState>(
  fromMediaState.inRoomMediaStateFeatureKey
);

export const selectedMediaStateEntities = createSelector(selectMediaState, fromMediaState.selectMediaStateEntities);

export const selectCurrentMediaState = createSelector(
  selectedMediaStateEntities,
  VirtualRoomRouterStoreSelectors.selectLocation,
  VirtualRoomRouterStoreSelectors.selectRoom,
  (entities, location: string, room: string) => {
    return entities[fromMediaState.selectMediaStateId(location, room)];
  }
);
